<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Operation Theatre Technology</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science in Operation Theatre Technology</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Operation Theatre
                    Technology </b>
                    – The Bachelor of Science in Operation Theatre Technology (B.Sc. OTT) offered by ARNI School of
                    Allied Health Science is a specialized undergraduate program designed to train students in the
                    advanced techniques and technologies used in operation theatres. This program equips students with
                    the knowledge and skills required to assist surgeons, anesthesiologists, and other healthcare
                    professionals in surgical and emergency settings. This three-year degree program also offers 1-year
                    internship.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Introduction to the Healthcare Delivery System</li>
                    <li> Human Anatomy</li>
                    <li> Human Physiology</li>
                    <li> Environmental Science</li>
                    <li> Basics of Computer</li>
                    <li> Elective – I</li>
                    <li> Human Anatomy and Physiology-Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Pathology</li>
                    <li> English Communication</li>
                    <li> Biochemistry</li>
                    <li> Clinical Microbiology</li>
                    <li> Medical Law and Ethics</li>
                    <li> Principles of Anaesthesia</li>
                    <li> Elective – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Clinical Observership – I</li>
                    <li> Medicine</li>
                    <li> Medical Terminology and Record keeping</li>
                    <li> Clinical Pharmacology</li>
                    <li> Applied Anatomy and Physiology</li>
                    <li> Elective – III (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Quality and Patient Safety</li>
                    <li> Clinical Observership II</li>
                    <li> Principals of Management</li>
                    <li> Medicine Outline</li>
                    <li> Elective -IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> CSSD Procedures</li>
                    <li> Basic Intensive care</li>
                    <li> Basics of Surgical procedures</li>
                    <li> Anesthesia for Specialty Surgeries</li>
                    <li> Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Electronics and Technology in Surgery and Anesthesia</li>
                    <li> Basic Administration and Equipment Maintenance</li>
                    <li> Research Methodology and Bio-Statistics</li>
                    <li> Project and Dissertation</li>
                </ul>
            </div>


        </div>

    </div>
</section>
